/**
 * Headline numbers from replaying the martingale rules (btc15Martingale.ts)
 * over the site's archived Kalshi opening quotes and Kalshi's official
 * results, recorded by hand when the test was registered, so the page can
 * show them next to the forward test. Full results: docs/MARTINGALE.md.
 */
export interface MartingaleReplaySide {
  pnl: number;
  busts: number;
  cycles: number;
  longestStreak: number;
  maxStake: number;
  fees: number;
}

export interface MartingaleReplaySnapshot {
  window: string;
  rounds: number;
  up: MartingaleReplaySide;
  down: MartingaleReplaySide;
  note: string;
}

export const MARTINGALE_REPLAY: MartingaleReplaySnapshot = {
  window: 'Sep 22 – Oct 15, 2026',
  rounds: 2222,
  up: {
    pnl: -363.21,
    busts: 7,
    cycles: 1099,
    longestStreak: 8,
    maxStake: 313.89,
    fees: 392.63,
  },
  down: {
    pnl: -1401.32,
    busts: 13,
    cycles: 1123,
    longestStreak: 8,
    maxStake: 214.95,
    fees: 376.79,
  },
  note: 'Each side won about 1,100 chains at $1 apiece and gave it all back, and more, in its busts. Fees alone cost about $380 a side. A chain can bust after 4–6 losses when the opening ask is far from 50¢, because each recovery stake then grows faster than doubling.',
};
